"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : EDIT INFO CTA : STYLES --------------- ++++++++++ */


var _default = {
  editinfo: {
    '& .name-discard-changes': {
      marginRight: (0, _index.pxToEm)(10)
    }
  }
};
exports.default = _default;